
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";

import { getExamSyllabusList, getSyllabusPatternList } from './questionPaperSvc';
import ExamHeader from './examHeader';
import SyllabusClasses from './syllabusClasses';
import ExamSubjectTbl from './examSubjectsTbl';

function ExamSubjectDetailsCtrl() {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [examId, setExamId] = useState(0);
    const [exam, setExam] = useState({});
    const [syllabusId, setSyllabusId] = useState(0);
    const [lstPattern, setLstPattern] = useState([]);
    const [key, setKey] = useState(0);



    useEffect(() => {
        // console.log("ExamSubjectDetailsCtrl called");
        getListPattern();
    }, []);



    const changeExam = (pExam) => {
        // console.log("changeExam called, pExam", pExam);
        setExam(pExam);
        setExamId(pExam.examId);
    }

    const getListPattern = () => {
        // console.log("getListPattern called");
        setLoader("block");
        setOpacity(0.5);
        getSyllabusPatternList(patternListResponse);
    }

    const patternListResponse = (data) => {
        // console.log("patternListResponse called");
        if (data.status === "Success") {
            setLstPattern(data.lstPattern);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    const handleSyllabusChange = (pSybId) => {
        // console.log("handleSyllabusChange called, pSybId", pSybId);
        setSyllabusId(pSybId);
    }

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }



    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (opacity === 1) ? 'pointer' : 'none',
                    pointerEvents: (opacity === 1) ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-lg-8 col-md-9 col-sm-10 col-xs-12 col-centered padding-remove">
                <div className="col-md-12 col-xs-12 padding-remove col-centered">
                    <SyllabusClasses
                        syllabusId={syllabusId}
                        handleSyllabusChange={handleSyllabusChange}
                        setLoader={setLoader}
                        setOpacity={setOpacity}
                    />
                </div>
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                    <ExamHeader
                        changeExam={changeExam}
                        examId={examId}
                    />
                </div>
                <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "80px" }}>
                    <ExamSubjectTbl
                        lstPattern={lstPattern}
                        examId={examId}
                        syllabusId={syllabusId}
                        setLoader={setLoader}
                        setOpacity={setOpacity}
                        key={key}
                        updateKey={updateKey}
                    />
                </div>
            </div>
        </div >
    )
}
export default ExamSubjectDetailsCtrl;
